import { render, staticRenderFns } from "./DocumentListItem.vue?vue&type=template&id=d2f0296c&scoped=true"
import script from "./DocumentListItem.vue?vue&type=script&lang=ts"
export * from "./DocumentListItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2f0296c",
  null
  
)

export default component.exports